import { render, staticRenderFns } from "./PromotionCorner.vue?vue&type=template&id=50e7c4ce&scoped=true"
import script from "./PromotionCorner.vue?vue&type=script&lang=js"
export * from "./PromotionCorner.vue?vue&type=script&lang=js"
import style0 from "./PromotionCorner.vue?vue&type=style&index=0&id=50e7c4ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e7c4ce",
  null
  
)

export default component.exports